if (!customElements.get('product-item')) {
  class ProductItem extends HTMLElement {
    constructor() {
      super();
    }

    handleSwatchChange(event) {
      event.preventDefault();
      const newImageSrc = this.getAttribute(`data-image-${event.detail.color}`);
      if(!newImageSrc) return;

      this.imageElements.forEach(image => {
        image.removeAttribute('srcset');
        image.src = newImageSrc;
      })
    }

    connectedCallback() {
      const productItem = this;
      this.slider = this.querySelector('.swiper');
      this.options = {
        draggable: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
        },
      };

      if (this.slider) {
        this.sliderEl = new Swiper(this.slider, this.options);
        this.sliderEl.on('slideChange', function (slider) {
          if(slider.activeIndex >= 1){
            productItem.querySelector('.product-item__svg-badge')?.classList.add('active')
          }else{
            productItem.querySelector('.product-item__svg-badge')?.classList.remove('active')
          }
        });
      }

      this.imageElements = this.querySelectorAll('.js-item-media img:first-child');
      if(!this.imageElements.length) return;

      this.addEventListener('alexa:swatch-change', this.handleSwatchChange.bind(this));
    }
  }
  customElements.define('product-item', ProductItem);
}
